import operations from '~/helpers/device-operations';
import { ticStatus, ticType } from '~/helpers/fields-description';
import { connectivity } from '~/helpers/network-fields-description';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { LegrandGateway } from './LegrandGateway.model';

export class NLE extends LegrandGateway {
    tic_link_state?: boolean;
    tic_version?: number;

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.switchDatabase({
                callback: this.switchDatabase,
                disabled: this.isSwitchDatabaseDisabled,
            }),
        ]);
    }

    get fieldRoom() {
        return undefined;
    }
    get fieldName() {
        return undefined;
    }
    get fieldHwVersion() {
        return undefined;
    }
    get fieldLastSetup() {
        return undefined;
    }
    get fieldLastStatusStored() {
        return undefined;
    }
    get fieldUptime() {
        return undefined;
    }
    get fieldTicStatus(): FieldObject | undefined {
        return ticStatus(this.tic_link_state);
    }
    get fieldTicType(): FieldObject | undefined {
        if (this.tic_link_state) {
            return ticType(this.tic_version || -1);
        }
    }

    getNetworkFields(): FieldObject[] {
        const fields = super.getNetworkFields();
        fields.push(connectivity(this.network?.connection as string));
        return fields;
    }

}
